import React from 'react';
import PropTypes from 'prop-types';

import ChevronUp from '@olxbr/olx-icons/dist/System/ChevronUp';
import ChevronDown from '@olxbr/olx-icons/dist/System/ChevronDown';

import {
  Item,
  Header,
  Wrapper,
  ListItems,
  Title,
} from './styles';
import useDropdown from './useDropdown';
import AD_QUANTITY from './constants';

function Dropdown({ onSelect, openContactModal, posData }) {
  const dropdown = useDropdown(onSelect, openContactModal, posData);

  return (
    <Wrapper justifyContent="center">
      <Header
        open={dropdown.isOpen}
        onClick={() => dropdown.onClick(!dropdown.isOpen)}
      >
        <Title>{dropdown.title}</Title>
        {dropdown.isOpen
          ? <ChevronUp width={16} height={16} />
          : <ChevronDown width={16} height={16} />
        }
      </Header>
      {dropdown.isOpen && (
        <ListItems onClick={e => e.stopPropagation()} width="200px">
          {AD_QUANTITY.map(({ text, value }) => (
            <Item
              key={value}
              onClick={() => dropdown.onClickItem(text, value)}
            >
              {text}
            </Item>
          ))}
        </ListItems>
      )}
    </Wrapper>
  );
}

Dropdown.propTypes = {
  onSelect: PropTypes.func.isRequired,
  openContactModal: PropTypes.func.isRequired,
  posData: PropTypes.object.isRequired,
};

export default Dropdown;
